import React, { useState, useEffect } from 'react'
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga';
import CustomNavbar from '../../customNavbar';
import { CustomAlertBox } from '../../../shared/customAlertBox';
import { Col, Row, Image, Alert, Dropdown } from 'react-bootstrap';
import { CustomSearch } from '../../../shared/customSearch';
import { CustomButton } from '../../../shared/customButton';
import MaterialTable from "material-table";
import styles from './quizTemplates.module.scss';
import makeAnimated from 'react-select/animated';
import CreateQuizTemplateModal from './createQuizTemplateModal';
import { getAllQuizTemplates, copyTemplateToNew, activateQuizTemplate, putBackToDraft, checkIfTemplateEligibleToDisableOrPutBackToDraft } from '../../../../services/util/quizTemplates';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import ViewQuizTemplates from './viewQuizTemplate';
import ReactTooltip from 'react-tooltip';
import { CustomConfirmationModal } from '../../../shared/customConfirmationModal';
import CSSLoader from '../../../shared/cssLoader';

let moment = require('moment-timezone');


const QuizTemplates = (props) => {

    const animatedComponents = makeAnimated();
    const history = useHistory();
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let seleted_state = (params.get('state') ? params.get('state') : 100);

    let [getUsersIsLoading, getUsersSetLoading] = useState(false);
    let [filteredValues, setFilteredValues] = useState([]);
    let [value, setArrayValues] = useState([]);
    let [isURLLoading, setURLLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    let [noSearchData, setNoSearchData] = useState(false)
    let [getQuizTemplate, getSetQuizTemplate] = useState(false);
    let [showCopyToNewPopup, setShowCopyToNewPopup] = useState(false);
    let [isDataLoading, setDataLoading] = useState(false);

    const breadcrumb = [{
        pathaddress: 'app/company/templates/quiz-templates',
        pathname: 'Quiz Templates',
        isActive: true,
        key: 1 + 'Quiz Templates'
    }]

    //set an state for default seleted pipeline type
    let [defaultSelectedPipelineType, setDefaultSelectedPipelineType] = useState({
        label: "Active and Draft",
        value: 100
    })

    //dropdown values of pipeline types
    const pipelineTypes = [
        {
            label: "Active and Draft",
            value: 100
        },
        {
            label: "Active",
            value: 10
        },
        {
            label: "Draft",
            value: 0
        },
        {
            label: "Disabled",
            value: -10
        }
    ];

    // functions
    const handleClose = () => setShowModal(false);
    const handleShow = () => setShowModal(true);

    function viewQuizTemplates(value) {
        getSetQuizTemplate(true)
        history.push(`/app/company/quiz-template/${value}`);
    }


    const getAllQuizTemplateDetails = async () => {
        setDataLoading(true);
        getUsersSetLoading(true)
        let response = await getAllQuizTemplates(seleted_state);
        if (response.success == true) {
            //setting pipleine label for selected state
            if (seleted_state != 100) {
                for (let index = 0; index < pipelineTypes.length; index++) {
                    if (pipelineTypes[index].value == seleted_state) {
                        setDefaultSelectedPipelineType(pipelineTypes[index]);

                    }
                }
            }
            setArrayValues(response.data);
            setFilteredValues(response.data);
            getUsersSetLoading(false);
            setDataLoading(false);
        } else {
            getUsersSetLoading(false);
            setDataLoading(false);
        }
    }

    const changePipelineType = async (type) => {
        getUsersSetLoading(true);
        setDefaultSelectedPipelineType(type);
        let respond = await getAllQuizTemplates(type.value);
        if (respond.success === true) {
            setFilteredValues(respond.data);
            getUsersSetLoading(false)
        } else {
            getUsersSetLoading(false)
        }

    };


    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }

    const changeSelectedStateURL = async (state) => {
        history.push({
            pathname: `/app/company/templates/quiz-templates`,
            search: `?state=${state}`
        });
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    function viewQuiz(value) {
        history.push(`/app/company/quiz-templates/${value}`);
        handleClose();
    }



    const copyToNew = async (Value) => {
        let response = await copyTemplateToNew(Value);
        if (response.success == true) {
            history.push(`/app/company/templates/quiz-templates`);
            handleClose();
        } else {
        }
    }
    const activateTemplate = async (Value) => {
        let response = await activateQuizTemplate(Value);
        if (response.success == true) {
            history.push(`/app/company/templates/quiz-templates`);
            handleClose();
        } else {

        }
    }

    const putToDraftAgain = async (value) => {
        let responses = await checkIfTemplateEligibleToDisableOrPutBackToDraft(value);
        if (responses.success == true) {
            let response = await putBackToDraft(value);
            if (response.success == true) {
                history.push(`/app/company/templates/quiz-templates`);
                handleClose();
            } else {
            }
        }

    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        getAllQuizTemplateDetails();
    }, [])

    return (
        <div >
            <Helmet>
                <title>Templates | HireTrace</title>
            </Helmet>
            {
                showModal === true ?
                    <CreateQuizTemplateModal showModal={showModal} handleClose={handleClose} />
                    : null
            }
            {isDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                <div>
                    <div>
                        {getQuizTemplate === true ? <ViewQuizTemplates /> :
                            <div>
                                <div className={styles.backgroundFixedComponents}>
                                    <Col className='m-0 p-0'>
                                        <div>
                                            <Row>
                                                <Col sm={2} className="mb-2">
                                                    <Select
                                                        options={pipelineTypes}
                                                        class="react-select__control"
                                                        components={animatedComponents}
                                                        value={defaultSelectedPipelineType}
                                                        onChange={(e) => {
                                                            changePipelineType(e);
                                                            changeSelectedStateURL(e.value)
                                                        }}
                                                        styles={
                                                            {
                                                                ...styles,
                                                                control: (base, state) => ({
                                                                    ...base,
                                                                    '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                                    border: '1px solid #bdbdbd', // default border color
                                                                    borderRadius: '6px',
                                                                    boxShadow: 'none', // no box-shadow
                                                                    height: '48px',
                                                                    fontFamily: 'var(--app-primary-font-style)',
                                                                    fontWeight: 'var(--app-regular-font-weight)',
                                                                    fontSize: 'var(--app-primary-font-size)',
                                                                }),
                                                                option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                                    return {
                                                                        ...styles,
                                                                        background: isDisabled
                                                                            ? null
                                                                            : isSelected
                                                                                ? 'rgba(45, 166, 192, 0.1)'
                                                                                : isFocused
                                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                                    : null,
                                                                        color: isDisabled
                                                                            ? '#ccc'
                                                                            : isSelected
                                                                                ? '#24859A'
                                                                                : '#24859A',
                                                                        cursor: isDisabled ? 'not-allowed' : 'default',

                                                                        ':active': {
                                                                            ...styles[':active'],
                                                                            background:
                                                                                !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                        },
                                                                    };
                                                                },
                                                            }
                                                        }
                                                    />
                                                </Col>

                                                <Col sm={6} className="mb-2">
                                                    <CustomSearch
                                                        placeholder="Search Quizes"
                                                        handleOnChange={(e) => searchValus(e.target.value)}
                                                    />
                                                </Col>
                                                <Col>
                                                </Col>
                                                <Col sm={3} className="mb-2">
                                                    <CustomButton
                                                        buttonType="button"
                                                        label="Create New Quiz"
                                                        type="primaryBtn"
                                                        frontIcon={
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                                                <path d="M10.5001 4.16666V15.8333M4.66675 10H16.3334" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        }
                                                        handleClick={handleShow}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>

                                    </Col>
                                </div>

                                <div className={styles.tableBodyContainer}>
                                    {
                                        ((filteredValues.length === 0) && (getUsersIsLoading === false)) ?
                                            (<div>
                                                {noSearchData ?
                                                    <Col>
                                                        <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                                    </Col>
                                                    :
                                                    <div>
                                                        <Col>
                                                            <p className={styles.infoMessage}>You haven't created any Quiz Templates yet. Create now.
                                                            </p>
                                                        </Col>
                                                        <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                            <div className={styles.noQuizImg}>
                                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/quiz.svg`} fluid />
                                                            </div>

                                                        </Col>
                                                    </div>


                                                }

                                            </div>)
                                            :
                                            (
                                                <>
                                                    <div className={styles.tableContainer}>
                                                        <div className={styles.quizFirstRowMainHeaderDiv}>
                                                            <Col sm={4} className={styles.quizPipelineDetailsMainHeaderRow}>
                                                                <p>Quiz Details</p>
                                                            </Col>
                                                            <Col sm={2}>
                                                                <Row className={styles.quizInfoDetailsMainHeaderRow}>
                                                                    <p>Quiz Duration / Ques. Count</p>
                                                                </Row>
                                                            </Col>
                                                            <Col sm={1} className={styles.quizStstusDetailsMainHeaderRow}>
                                                                <p>Status</p>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Row className={styles.quizCandidatesInfoDetailsHeaderRow}>
                                                                    <p>Last Updated at</p>
                                                                </Row>
                                                            </Col>
                                                            <Col sm={1}>
                                                                <Row className={styles.quizShareLinksHeaderRow}>
                                                                    <p>AVG Score</p>
                                                                </Row>
                                                            </Col>
                                                            <Col sm={1}>
                                                            </Col>
                                                        </div>
                                                        {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((quiz, i) => {
                                                            return (
                                                                <div className={i % 2 === 0 ? styles.quizRowMainDiv : styles.quizRowSecondMainDiv} >
                                                                    <Col sm={4} onClick={() => viewQuiz(quiz?.quiz_template_id)}>
                                                                        <Row className={styles.quizJobDetailsMainRow}>
                                                                            <Col sm={2}>
                                                                                <div className={styles.quizMainIconDiv}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                                                                        <path d="M1 15L14.4991 21.7896C14.6828 21.882 14.7746 21.9282 14.8709 21.9464C14.9562 21.9625 15.0438 21.9625 15.1291 21.9464C15.2254 21.9282 15.3172 21.882 15.5009 21.7896L29 15M1 22.0416L14.4991 28.8312C14.6828 28.9236 14.7746 28.9697 14.8709 28.9879C14.9562 29.004 15.0438 29.004 15.1291 28.9879C15.2254 28.9697 15.3172 28.9236 15.5009 28.8312L29 22.0416M1 7.95844L14.4991 1.16881C14.6828 1.07644 14.7746 1.03025 14.8709 1.01208C14.9562 0.995975 15.0438 0.995975 15.1291 1.01208C15.2254 1.03025 15.3172 1.07644 15.5009 1.16881L29 7.95844L15.5009 14.7481C15.3172 14.8404 15.2254 14.8866 15.1291 14.9048C15.0438 14.9209 14.9562 14.9209 14.8709 14.9048C14.7746 14.8866 14.6828 14.8404 14.4991 14.7481L1 7.95844Z" stroke="#2DA6C0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                                    </svg>
                                                                                </div>
                                                                            </Col>
                                                                            <Col sm={10}>
                                                                                <Row className={styles.quizJobDetailsRow}>
                                                                                    <p className={styles.quizJobDetails}>{quiz?.specialization}</p>
                                                                                </Row>
                                                                                <Row className={styles.quizJobDetailsRow}>
                                                                                    <p className={styles.quizSecondJobDetails}>{quiz?.name}</p>
                                                                                </Row>
                                                                            </Col>

                                                                        </Row>
                                                                    </Col>
                                                                    <Col sm={2}>
                                                                        <Row className={styles.quizCandidatesInfoDetailsRow}>
                                                                            <p className={styles.quizCandidatesInfoDetails}>
                                                                                <span style={{ marginRight: '10px' }}>{quiz?.duration}min</span>/
                                                                                <span style={{ marginRight: '10px', marginLeft: '10px' }}>{quiz?.question_count}ques</span>
                                                                            </p>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col sm={1} className='d-flex align-items-center justify-content-center'>
                                                                        <div className={quiz.state === 10 ? styles.quizStatusDetailsMainDiv : quiz.state === 0 ? styles.quizStatusDetailsDraftMainDiv : styles.quizStatusDetailsDisableMainDiv}>
                                                                            {quiz.state === 10 ? <p className={styles.quizStatusDetails}>Active</p> : quiz.state === 0 ? <p className={styles.quizStatusDraftDetails}>Draft</p> : quiz.state === -10 ? <p className={styles.quizStatusDisableDetails}>Disable</p> : null}
                                                                        </div>
                                                                    </Col>
                                                                    <Col sm={3}>
                                                                        <Row className={styles.quizCandidatesLastUpdateDetailsRow}>
                                                                            <p className={styles.quizCandidatesLastUpdateDetails}>
                                                                                {moment.tz(quiz.last_updated_at, moment.tz.guess()).format('DD MMM YYYY, HH:mmA')}
                                                                            </p>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col sm={1}>
                                                                        <Row className={styles.quizCandidatesAvgScoreDetailsRow}>
                                                                            <p className={styles.quizCandidatesAvgScoreDetails}>{quiz?.avg_score}</p>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col sm={1}>
                                                                        <Row className={styles.quizOptionRow}>
                                                                            <div className={styles.quizOptionIconDiv}>
                                                                                <Dropdown
                                                                                    alignRight={true}
                                                                                >
                                                                                    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                                    </Dropdown.Toggle>
                                                                                    <Dropdown.Menu className={styles.dropdownMenu}>
                                                                                        <Dropdown.Item onClick={() => viewQuiz(quiz?.quiz_template_id)} className={styles.dropdownText}>View</Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => copyToNew(quiz?.quiz_template_id)} className={styles.dropdownText}>clone</Dropdown.Item>
                                                                                        {quiz?.question_count > 0 ?
                                                                                            <>
                                                                                                {quiz?.state === 0 ?
                                                                                                    <Dropdown.Item onClick={() => activateTemplate(quiz?.quiz_template_id)} className={styles.dropdownText}>Active</Dropdown.Item>
                                                                                                    :
                                                                                                    quiz?.state === 10 ?
                                                                                                        <Dropdown.Item onClick={() => putToDraftAgain(quiz?.quiz_template_id)} className={styles.dropdownText}>Draft</Dropdown.Item>
                                                                                                        :
                                                                                                        null
                                                                                                }
                                                                                            </>
                                                                                            :
                                                                                            null
                                                                                        }
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </div>
                                                                        </Row>
                                                                    </Col>
                                                                </div>
                                                            )
                                                        })
                                                        }

                                                    </div>
                                                    <div>
                                                        {filteredValues.length > 9 && getUsersIsLoading === false &&
                                                            <div className={styles.bottomTableDiv}>
                                                                <div className={styles.bottomTableControlsWrapper}>
                                                                    <div className={styles.bottomTableControlsNextBtn}>
                                                                        <CustomButton
                                                                            id="quiz_templates_go_to_previous_page_btn"
                                                                            label="Previous"
                                                                            handleClick={handlePreviousClick}
                                                                            disabled={currentPage === 1}
                                                                            type="defaultSmallBtn"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <CustomButton
                                                                            id="quiz_templates_go_to_next_page_btn"
                                                                            label="Next"
                                                                            type="defaultSmallBtn"
                                                                            handleClick={handleNextClick}
                                                                            disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <span className={styles.paginationInfo}>
                                                                        Page {currentPage} of {totalPages}
                                                                    </span>
                                                                </div>

                                                            </div>
                                                        }
                                                    </div>
                                                </>)
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    )
}

export default QuizTemplates